export const mapStatus = (game) => {
  switch (game?.gameResult) {
    case "WIN":
      return { status: "win", result: "You Win" };
    case "LOSE":
      return { status: "loss", result: "You Lose" };
    case "TIE":
    case "DRAW":
      return { status: "tie", result: "You Tie" };
    case "VOID":
      return { status: "void", result: "No match found" };
    case "MATCH_IN_PROGRESS":
      return game?.opponent
        ? { status: "reveal", result: "Awaiting results" }
        : { status: "waiting", result: "Waiting for an opponent" };
    default:
      return { status: "pending", result: "" };
  }
};
